import CryptoJS from 'crypto-js'
/**
 * @description: ase加密
 * @param {word} 要加密的内容
 * @param {keyWord} String  服务器随机返回的关键字
 * @return: 
 * @author: tanglitong
 */
export function aesEncrypt(word, keyWord = process.env.VUE_APP_KEY_WORD) {
    var key = CryptoJS.enc.Utf8.parse(keyWord);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}
/**
 * @description: 自定义ase加密
 * @return {type} 
 */
export function aesEncryptWord(word, keyWord = process.env.VUE_APP_KEY_WORD) {
  // var key = CryptoJS.enc.Utf8.parse(keyWordDecrypt(keyWord))
  var key = CryptoJS.enc.Utf8.parse(keyWord)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
function keyWordDecrypt(keyWord, chunk = 4, order = [0.5,0.375,0.125,0.25]) {
  const keyWordArr = keyWord.split('')
  let mergeArr = []
  let mergeStr = ''
  for (let i = 0, j = keyWordArr.length; i < j; i += chunk) {
    mergeArr.push(keyWordArr.slice(i, i + chunk).join(''))
  }

  order.forEach(element => {
    mergeStr += (mergeArr[element * 8 - 1])
  });
  return mergeStr
}


// WEBPACK FOOTER //
// ./src/components/verifition/utils/ase.js